var _path, _path2, _circle, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpgrade = function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.668 6.592S3.032 5.337.524 10.297c0 0 3.192-.03 4.05 2.199.857 2.23 3.094-5.904 3.094-5.904ZM13.265 12.19s1.255 4.635-3.704 7.144c0 0 .03-3.192-2.2-4.05-2.229-.858 5.904-3.095 5.904-3.095Z",
    fill: "#87DDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12 7.644a9.576 9.576 0 0 1 10.588-5.492v0a9.576 9.576 0 0 1-5.491 10.588L7.59 14.807l-1.268-1.268-1.268-1.268L7.12 7.644Z",
    fill: "#0093B9",
    stroke: "#0093B9",
    strokeWidth: 1.315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.136,
    cy: 6.622,
    r: 2.626,
    transform: "rotate(45 13.136 6.622)",
    fill: "url(#Upgrade_svg__a)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.914,
    cy: 15.947,
    rx: 1.725,
    ry: 2.255,
    transform: "rotate(45 3.914 15.947)",
    fill: "url(#Upgrade_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Upgrade_svg__a",
    x1: 10.51,
    y1: 3.995,
    x2: 10.51,
    y2: 9.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C8E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Upgrade_svg__b",
    x1: 2.188,
    y1: 13.692,
    x2: 2.188,
    y2: 18.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC788"
  })))));
};
export default SvgUpgrade;